import React, { Component } from 'react';
import { Link } from 'react-router-dom';
class Sidebar extends Component {
    render() {
        return (
            <div id="sidebar">
                <div className="themesflat-spacer clearfix" data-desktop={80} data-mobile={0} data-smobile={0} />
                <div id="inner-sidebar" className="inner-content-wrap">
                    <div className="widget widget_list">
                        <div className="inner">
                            <ul className="list-wrap">
                                <li className="list-item">
                                    <Link to="#"><span className="text">Plywood & MDF Boards</span></Link>
                                </li>
                                <li className="list-item">
                                    <Link to="#"><span className="text">Block Boards & Chip Boards</span></Link>
                                </li>
                                <li className="list-item">
                                    <Link to="#"><span className="text">Doors & Hardware</span></Link>
                                </li>
                                <li className="list-item">
                                    <Link to="#"><span className="text">Paints & Finishes</span></Link>
                                </li>
                                <li className="list-item">
                                    <Link to="#"><span className="text">Tools & Fasteners</span></Link>
                                </li>
                                <li className="list-item">
                                    <Link to="#"><span className="text">Cement & Adhesives</span></Link>
                                </li>
                                <li className="list-item">
                                    <Link to="#"><span className="text">Marble Sheets & Laminates</span></Link>
                                </li>
                                <li className="list-item">
                                    <Link to="#"><span className="text">Sandpaper & Lipping</span></Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="widget widget_help align-center has-shadow no-sep has-border border-solid">
                        <div className="inner">
                            <h2 className="widget-title margin-bottom-14"><span>HOW CAN WE HELP ?</span></h2>
                            <p className="text line-height-26 margin-bottom-23">
                                Need quality building materials? Contact us for bulk orders, product inquiries, or visit our store in Nairobi.
                            </p>
                            <div className="elm-button">
                                <Link to="#" className="themesflat-button bg-accent pd30">CONTACT US</Link>
                            </div>
                            <div className="themesflat-spacer clearfix" data-desktop={20} data-mobile={20} data-smobile={20} />
                            <p className="text line-height-26">
                                <strong>CEO:</strong> 0706494665<br/>
                                <strong>Sales Manager:</strong> 0729926703
                            </p>
                        </div>
                    </div>
                </div>
                <div className="themesflat-spacer clearfix" data-desktop={0} data-mobile={60} data-smobile={60} />
            </div>
        );
    }
}

export default Sidebar;